import { SVGProps } from 'react';

export const SortIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.33357 5.89609L9.66637 4.56329L5.22967 0.126587L0.792969 4.56329L2.12577 5.89609L4.28709 3.73476V14.6554H6.17224V3.73476L8.33357 5.89609Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.8746 12.1039L13.7133 14.2652V3.34454H11.8281V14.2652L9.66679 12.1039L8.33398 13.4367L12.7707 17.8734L17.2074 13.4367L15.8746 12.1039Z"
        fill="currentColor"
      />
    </svg>
  );
};
